import { render } from "./Basic.vue?vue&type=template&id=2f8dfe49&scoped=true"
import script from "./Basic.vue?vue&type=script&lang=ts"
export * from "./Basic.vue?vue&type=script&lang=ts"

import "./Basic.vue?vue&type=style&index=0&id=2f8dfe49&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-2f8dfe49"

export default script